/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useController } from 'react-hook-form';
import { Form, Input } from 'antd';

const AntdTextPosField = ({
  setValue,
  control,
  name,
  type,
  label,
  placeholder,
  prefix,
  validateStatus,
  defaultValue,
  errorMsg,
  className,
  onInputChange,
  autoFocus,
  ref = null // value
}) => {
  const {
    // field: { ...inputProps }
    field
  } = useController({
    name,
    control
  });

  React.useEffect(() => {
    if (defaultValue) {
      setValue(name, defaultValue);
    }
  }, [defaultValue]);

  return (
    <Form.Item
      label={label}
      help={errorMsg}
      validateStatus={validateStatus}
      colon={false}
    >
      <Input
        autoFocus={autoFocus ? true : false}
        {...field}
        onChange={(e) => {
          field.onChange(e);
          onInputChange && onInputChange();
        }}
        className={className}
        placeholder={placeholder}
        prefix={prefix}
        type={type}
        size="large"
        ref={ref}
        defaultValue={defaultValue}
        // value={field.value ? field.value : defaultValue}
      />
    </Form.Item>
  );
};

export default AntdTextPosField;
